import request from './request'

const dicts = {
  '$NY': [
    { value: 1, label: '是' },
    { value: 0, label: '否' },
  ],
  '$YN': [
    { value: 0, label: '是' },
    { value: 1, label: '否' },
  ],
  '$state': [
    { value: 0, label: '无效' },
    { value: 1, label: '有效' },
  ],
  'stateN': [
    { value: 0, label: '有效' },
    { value: 1, label: '无效' },
  ],
  '$enable': [
    { value: 0, label: '启用' },
    { value: 1, label: '禁用' },
  ],
  '$gender': [
    { value: 0, label: '男性' },
    { value: 1, label: '女性' },
  ],
  '$appSystem': [
    { value: '', label: '通用' },
    { value: 'TYZL_MALL', label: '商城系统' },
    { value: 'TYZL_EXAM', label: '考试系统' },
    { value: 'LSP_MANAGE', label: '定位服务平台-管理平台服务' },
    { value: 'LSP_MOBILE', label: '定位服务平台-移动端服务' },
  ],
  '$accountType':[
    { value: 1, label: '独立账户' },
    { value: 2, label: '企业账户' },
  ],

  '$billingState': [
    { value: 0, label: '未计费' },
    { value: 1, label: '计费中' },
    { value: 2, label: '停止计费' },
  ],
  '$lockState':[
    { value: 0, label: '未锁定' },
    { value: 1, label: '用户锁定' },
  ],
  '$carLockState':[
    { value: 0, label: '未锁车' },
    { value: 1, label: '已锁车' },
  ],
  '$carLockerType':[
    { value: 3, label: '系统管理员' },
    { value: 5, label: '企业用户' },
  ],
  'carMultipleState':[
    { value: 0, label: '正常' },
    { value: 1, label: '禁用' },
    { value: 2, label: '已锁定' },
    { value: 3, label: '未启用' },
    { value: 6, label: '行驶中'},
  ],
  'carInsuranceState':[
    { value: 0, label: '无保险' },
    { value: 1, label: '有保险' },
    { value: 2, label: '保险到期' },
  ],
  //0、正常；1、禁用；2、已锁定；3、未启用；4、已启动；5、已停止；6、使用中
  '$carOnlineState':[
    { value: 1, label: '在线' },
    { value: 0, label: '离线' },
  ],
  '$driveState':[
    { value: 0, label: '未行驶' },
    { value: 1, label: '行驶中' },
  ],
  '$deviceState': [
    { value: 0, label: '未生效' },
    { value: 1, label: '生效中' },
    { value: 2, label: '失效' },
  ],
  '$deviceVendor': [
    { value: 0, label: '康凯斯智能中控定位器' },
  ],
  '$deviceBindState':[
    { value: 0, label: '已绑定' },
    { value: 1, label: '未绑定' },
  ],
  'mobile_operator':[
    { value: '中国电信', label: '中国电信' },
    { value: '中国移动', label: '中国移动' },
    { value: '中国联通', label: '中国联通' },
  ],
  '$buyOptions': [
    { value: 0, label: '全款' },
    { value: 1, label: '分期' },
  ],
  '$carType': [
    { value: 0, label: '三轮电动车' },
    { value: 1, label: '二轮电动车' },
    { value: 2, label: '四轮电动车' },
  ],
  'carSrc': [
    { value: 0, label: '自营车辆' },
    { value: 1, label: '旧车整改' },
  ],
  '$carUseState': [
    { value: 0, label: '使用中' },
    { value: 1, label: '已归还' },
  ],
  '$carBindState': [
    { value: 0, label: '未绑定' },
    { value: 1, label: '已绑定' },
  ],
  
  // 0 未展示 1 展示
  '$partsState':[
    { value: 0, label: '未展示' },
    { value: 1, label: '展示中' },
  ],
  '$fenceCate':[
    { value: 1, label: '圆形' },
    { value: 2, label: '矩形' },
    { value: 3, label: '多边形' },
  ],
  '$fenceStatus':[
    { value: -1, label: '未生效' },
    { value: 0, label: '启用' },
    { value: 1, label: '禁用' },
  ],
  '$carEnableState':[
    { value: 0, label: '未启用' },
    { value: 1, label: '启用' },
    { value: 2, label: '禁用' },
  ],
  '$userState': [
    { value: 0, label: '启用' },
    { value: 1, label: '禁用' },
    { value: 2, label: '冻结' },
    { value: 3, label: '黑名单' },
  ],
  '$userType':[
    { value: 0, label: '商城系统用户' },
    { value: 1, label: '考试系统:网点用户' },
    { value: 2, label: '考试系统:监管用户' },
    { value: 3, label: 'LSP系统:平台管理人员' },
    { value: 4, label: 'LSP系统:监管人员' },
    { value: 5, label: 'LSP系统:网点企业人员' },
    { value: 6, label: 'LSP系统:快递员' },
  ],
  '$tradeType':[
    { value: 0, label: '人工充值' },
    { value: 1, label: '分期费用自动扣费' },
    { value: 2, label: '网点充值' },
    { value: 3, label: '快递员充值' },
  ],
  '$fenceType':[
    { value: 0, label: '禁行区围栏' },
    { value: 1, label: '企业网点考勤围栏' },
    { value: 2, label: '工作区围栏' },
    { value: 3, label: '停放区围栏' },
  ],
  'fenceRuleType':[
    { value: 0, label: '长期有效' },
    { value: 1, label: '指定日期' },
  ],
  'fenceCycleRule':[
    { value: 0, label: '每日' },
    { value: 1, label: '法定工作日' },
    // { value: 1, label: '法定节假日' },
  ],
  '$fenceAlarm':[
    // { value: -1, label: '无' },
    { value: 0, label: '进报警' },
    { value: 1, label: '出报警' },
    { value: 2, label: '进出报警' },
  ],
  '$paySource':[
    { value: 3, label: '后台' },
    { value: 5, label: '网点' },
    { value: 6, label: '快递员' },
  ],
  '$payType':[
    { value: 0, label: '人工充值' },
    { value: 1, label: '支付宝充值' },
    { value: 2, label: '支付宝+优惠券' },
    { value: 3, label: '微信' },
    { value: 4, label: '微信+优惠券' },
  ],
  //0：待支付，1：已支付，2：支付成功，已到账，3：支付失败，4：退款进行中，5：退款处理成功，6：退款处理失败，7、超时关闭 8、扣费成功 9：交易失败',
  '$payStatus':[
    { value: 0, label: '未支付' },
    { value: 1, label: '已支付' },
    { value: 2, label: '支付成功' },
    { value: 3, label: '支付失败' },
    { value: 4, label: '退款进行中' },
    { value: 5, label: '退款处理成功' },
    { value: 6, label: '退款处理失败' },
    { value: 7, label: '超时关闭' },
    { value: 8, label: '扣费成功' },
    { value: 9, label: '交易失败' },
    // { value: 0, label: '已提交三方，未支付' },
    // { value: 1, label: '已提交三方，已支付' },
    // { value: 2, label: '三方已经回调，支付成功' },
    // { value: 3, label: '三方已经回调，支付失败' },
    // { value: 4, label: '退款进行中' },
    // { value: 5, label: '退款处理成功' },
    // { value: 6, label: '退款处理失败' },
  ],
  '$payMethod':[
    { value: 0, label: '支付宝' , icon:'icon-alipay' },
    { value: 1, label: '微信支付',icon:"icon-wechat" },
  ],
  '$region': [
    { value: 0, label: '大陆' },
    { value: 1, label: '香港' },
    { value: 2, label: '澳门' },
    { value: 3, label: '台湾' },
    { value: 4, label: '外籍' },
  ],
  '$regType': [
    { value: 1, label: '代理人注册' },
    { value: 2, label: '法人注册' },
  ],
  '$enterpriseCode': [
    { value: 'NORMAL', label: '组织机构代码号' },
    { value: 'MERGE', label: '社会信用代码号' },
    { value: 'REGCODE', label: '企业工商注册码' },
  ],

  '$enterprise': [
    { value: 0, label: '普通企业' },
    { value: 1, label: '社会团体' },
    { value: 2, label: '事业单位' },
    { value: 3, label: '民办非企业单位' },
    { value: 4, label: '党政及国家机构' }
  ],
  '$companyType': [
    { value: 1, label: '网点' },
    { value: 2, label: '企业' }
  ],
  //单位类型：0、金融与保险；1、金融；2、保险
  'partnerCompanyType': [
    { value: 0, label: '金融与保险' },
    { value: 1, label: '金融' },
    { value: 2, label: '保险' },
  ],
  //:0：合资、1：独资、2：国有、3：私营、4：全民所有制、5：集体所有制、6：股份制、7：有限责任
  '$companyNature': [
    { value: 0, label: '合资' },
    { value: 1, label: '独资' },
    { value: 2, label: '国有' },
    { value: 3, label: '私营' },
    { value: 4, label: '全民所有制' },
    { value: 5, label: '集体所有制' },
    { value: 6, label: '股份制' },
    { value: 7, label: '有限责任制' },
  ],
  //公司信息变更状态：0、待完善（已新建）；1、已提交（待审核）；2、待修改；3、正常
  'companyInfoStatus':[
    { value: 0, label: '待完善' },
    { value: 1, label: '待审核' },
    { value: 2, label: '待修改' },
    { value: 3, label: '正常' },
  ],
  //审批状态：0、已提交(审核中)；1、已通过；2、已拒绝；3、已取消
  'companyApplyStatus':[
    { value: 0, label: '审核中' },
    { value: 1, label: '已通过' },
    { value: 2, label: '已拒绝' },
    { value: 3, label: '已取消' },
  ],
  '$clearingType': [
    { value: 1, label: '日结算' },
    { value: 2, label: '周结算' },
    { value: 3, label: '月结算' },
    { value: 4, label: '季度结算' },
    { value: 5, label: '半年结算' },
    { value: 6, label: '周年结算' },
  ],
  '$buySubject': [
    { value: 0, label: '个人' },
    { value: 1, label: '公司' },
  ],
  '$targetType': [
    { value: 0, label: '个人' },
    { value: 1, label: '公司' },
  ],
  '$orderState': [
    { value: 1, label: '确认中' },
    { value: 2, label: '审核中' },
    { value: 3, label: '待收货' },
    // {value:4,label:'已驳回'},
    { value: 5, label: '已取消' },
    { value: 6, label: '已完成' },
  ],
  '$goodsOrderState': [
    { value: 1, label: '待处理' },
    { value: 2, label: '待支付' },
    { value: 3, label: '待签约' },
    { value: 4, label: '待发货'},
    { value: 5, label: '待收货' },
    { value: 6, label: '还款中' },
    { value: 7, label: '已完成' },
    { value: 8, label: '已取消' },
  ],
  '$flowState': [
    { value: 1, label: '待确认' },
    { value: 2, label: '待签约' },
    { value: 3, label: '签约中' },
    { value: 4, label: '签约失败' },
    { value: 5, label: '签约成功/未分期操作' },
    { value: 6, label: '分期申请中' },
    { value: 7, label: '分期成功' },
    { value: 8, label: '分期失败' },
    { value: 10, label: '待收货/已完成/已作废' },
    // {value:7,label:'分期签约推送'},
    // {value:8,label:'分期成功'},
    // {value:9,label:'分期失败'},
    // {value:10,label:'待收货/已完成/已作废'},
  ],
  // '$payType': [
  //   { value: 1, label: '线上支付' },
  //   { value: 2, label: '线下打款' },
  // ],
  '$validateResult': [
    { value: 1, label: '通过' },
    { value: 0, label: '不通过' }
  ],
  '$loanState': [
    { value: 0, label: '待发起' },
    { value: 1, label: '审批中' },
    { value: 2, label: '审批通过' },
    { value: 3, label: '未通过' },
  ],
  '$debtorType': [
    { value: 0, label: '主贷人' },
    { value: 1, label: '主贷人配偶' },
    { value: 2, label: '担保人' },
    { value: 3, label: '担保人配偶' },
    { value: 4, label: '反担保' },
    { value: 5, label: '反担保人配偶' },
  ],
  '$maritalStatus': [
    { value: 1, label: '已婚' },
    { value: 2, label: '未婚' },
    { value: 3, label: '丧偶' },
    { value: 4, label: '离异' },
  ],

  '$housingSituation': [
    { value: 1, label: '自购商品房' },
    { value: 2, label: '分期付款购房' },
    { value: 3, label: '自建房' },
    { value: 4, label: '房改房' },
    { value: 5, label: '居住父母家' },
    { value: 6, label: '居住亲朋家/单位集体宿舍/租房/其他' },
  ],
  '$questionType': [
    { value: 0, label: '判断题' },
    { value: 1, label: '单选题' },
    { value: 2, label: '多选题' },
    { value: 3, label: '问答题' },
  ],
  '$examTplType': [
    { value: 1, label: '考试' },
  ],
  '$examResult': [
    { value: 0, label: '通过' },
    { value: 1, label: '未通过' },
  ],
  'orgType': [
    { value: 0, label: '交警' },
    { value: 1, label: '邮政' },
    { value: 2, label: '综合单位' },
    { value: 3, label: '基础单位' },
  ],
  'orgProperty': [
    { value: 0, label: '其它' },
    { value: 1, label: '机关' },
    { value: 2, label: '事业' },
  ],
  'orgLevel': [
    { value: 1, label: '部' },
    { value: 2, label: '省' },
    { value: 3, label: '地（市）' },
    { value: 4, label: '县（市）' },
    { value: 5, label: '街道' },
    { value: 6, label: '乡镇' },
    { value: 7, label: '社区' },
    { value: 8, label: '行政村' },
  ],
  '$ciState': [
    { value: 0, label: '待查询' },
    { value: 1, label: '查询中' },
    { value: 2, label: '查询成功' },
    { value: 3, label: '查询失败' },
  ],

  '$appPlatform':[
    { value: 0, label: 'iOS' },
    { value: 1, label: 'Android' },
    { value: 2, label: 'Web' },
  ],

  '$ticketType':[
    { value: 0, label: '车辆报修' },
    { value: 1, label: '系统问题' },
    { value: 2, label: '投诉建议' },
  ],
  '$ticketState':[
    { value: 0, label: '未处理' },
    { value: 1, label: '已处理' },
  ],
  '$ticketSource':[
    { value: 0, label: '移动端APP' },
    { value: 1, label: '移动端Web' },
    { value: 2, label: '桌面端Web' },
  ],

  '$carOOCLockType':[
    { value: 0, label: '欠费未锁定' },
    { value: 1, label: '欠费已锁定' },
  ],

  'publishStatus':[
    { value: 0, label: '未发布' },
    { value: 1, label: '已发布' },
  ],
  //0:中共党员,1:中共预备党员,2:共青团员,3:民革党员,4:民盟盟员,5:民建会员,6:民进会员,7:农工党党员,8:致公党党员,9:九三学社社员,10:台盟盟员,11:无党派人士,12:群众
  'politic':[
    { value: 0, label: '中共党员' },
    { value: 1, label: '中共预备党员' },
    { value: 2, label: '共青团员' },
    { value: 3, label: '民革党员' },
    { value: 4, label: '民盟盟员' },
    { value: 5, label: '民建会员' },
    { value: 6, label: '民进会员' },
    { value: 7, label: '农工党党员' },
    { value: 8, label: '致公党党员' },
    { value: 9, label: '九三学社社员' },
    { value: 10,label: '台盟盟员' },
    { value: 11,label: '无党派人士' },
    { value: 12,label: '群众' },
  ],

  //0-待生成 10-待接单 20-待维修 30-维修中 40-待付款 50-已完成 60-已取消
  'assTicketState':[
    { value: 0, label: '待生成' },
    { value: 10, label: '待接单' },
    { value: 20, label: '待维修' },
    { value: 30, label: '维修中' },
    { value: 40, label: '待支付' },
    { value: 50, label: '已完成' },
    { value: 60, label: '已取消' },
  ],
  'assTicketStateForC':[
    { value: 0, label: '待生成' },
    { value: 10, label: '提交工单' },
    { value: 20, label: '接单' },
    { value: 30, label: '开始维修' },
    { value: 40, label: '已维修待支付' },
    { value: 50, label: '完成' },
    { value: 60, label: '取消工单' },
  ],
  'assType':[
    { value: 0, label: '站内维修' },
    { value: 1, label: '上门维修' },
  ],
  'assTicketStar':[
    { value: 1, label: '1星' },
    { value: 2, label: '2星' },
    { value: 3, label: '3星' },
    { value: 4, label: '4星' },
    { value: 5, label: '5星' },
  ],

  //0、电瓶；1、充电器；2、控制器；3、电机；4、制动类；5、电器件；6、车体件；7、易损件；8、其他
  'genre':[
    { value: 0, label: '电瓶' },
    { value: 1, label: '充电器' },
    { value: 2, label: '控制器' },
    { value: 3, label: '电机' },
    { value: 4, label: '制动类' },
    { value: 5, label: '电器件' },
    { value: 6, label: '车体件' },
    { value: 7, label: '易损件' },
    { value: 8, label: '其他' },
  ],

  'assPartsSource':[
    { value: 0, label: '原厂件' },
    { value: 1, label: '副厂件' },
  ],

  //安装单类型;1、控件安装，2、贴花，3、上牌。0、安装所有(控件、贴花、上牌)用户新增时使用
  'stdInstallationType':[
    // { value: 0, label: '安装所有' },
    { value: 1, label: '控件安装',selected:true , disabled:true},
    { value: 2, label: '贴花' },
    { value: 3, label: '上牌' },
  ],

  //0、待分配，1、待安装，2、待审核，3、已完成，4、已取消，5、已拒绝，6、不达标, 7已确认
  'stdInstallationState':[
    { value: 0, label: '待分配' },
    { value: 1, label: '待安装' },
    { value: 2, label: '待审核' },
    { value: 3, label: '已完成' },
    { value: 4, label: '已取消' },
    { value: 5, label: '已拒绝' },
    { value: 6, label: '不达标' },
    { value: 7, label: '已确认' },
  ],

  'stdInstallationReviewResult':[
    { value: 1, label: '成功' },
    { value: 2, label: '已拒绝' },
    { value: 3, label: '不达标' },
  ],
  //
  'stdInstallationRejectResult':[
    {value:3 , label:'车辆不达标'},
    {value:2 , label:'安装不通过'},
    {value:4 , label:'其他原因'},
  ],
  
  //0-待处理 10-待分配 20-进行中 30-已完成 40-已取消
  'stdApplicationState':[
    { value: 0, label: '待处理' },
    { value: 10, label: '待分配' },
    { value: 20, label: '进行中' },
    { value: 30, label: '已完成' },
    { value: 40, label: '已取消' },
  ],

  //车辆状态:0-待审核 10-信息待修改 20-待提交标准化 30-标准化进行中 40-标准化完成 50-不达标 60-已取消
  'stdCarState':[
    { value: 0, label: '待审核' },
    { value: 10, label: '信息待修改' },
    { value: 20, label: '待提交标准化' },
    { value: 30, label: '标准化进行中' },
    { value: 40, label: '标准化完成' },
    { value: 50, label: '不达标' },
    { value: 60, label: '已取消' },
  ],

  //0、待分配，1、待安装，2、待审核，3、已完成，4、已取消，5、已拒绝，6、不达标
  'stdCarPartsState':[
    { value: 0, label: '待分配' },
    { value: 1, label: '待安装' },
    { value: 2, label: '待审核' },
    { value: 3, label: '已完成' },
    { value: 4, label: '已取消' },
    { value: 5, label: '已拒绝' },
    { value: 6, label: '不达标' },
  ],

  'batteryType':[
    { value: 0, label: '铅酸蓄电池' },
    { value: 1, label: '锂电池' },
  ],

  'runType':[
    { value: 0, label: '加盟' },
    { value: 1, label: '直营' },
  ],
  //路径状态，10:派送中，20：已完成，30:已取消
  'routeState':[
    { value: 10, label: '派送中' },
    { value: 20, label: '已完成' },
    { value: 30, label: '已取消' },
  ],
  //接单模式 0、不限制(默认)，1、一单
  'employeeOrderModel':[
    { value: 0, label: '不限' },
    { value: 1, label: '仅一单' },
  ],
  //未申请，待审核，待考试，待发放，已发放
  //0、申请中，1、待开始考试，2、考试中，3，考试完成，4、申请不通过，5、驾照已经发放，6、待申请
  'examState':[
    { value: 6, label: '待申请' },
    { value: 0, label: '待审核' },
    { value: 1, label: '待考试' },
    { value: 2, label: '考试中' },
    { value: 3, label: '待发放' },
    { value: 4, label: '审核未通过' },
    { value: 5, label: '已发放' },
    { value: 7, label: '待补考' },
  ],
  //0-未激活 1-激活
  'activeState':[
    { value: 0, label: '未激活' },
    { value: 1, label: '已激活' },
  ],
  //备案状态I 0-未更新 1-待审核 2-已更新 3-未通过
  'carApplyState':[
    { value: 0, label: '未更新' },
    { value: 1, label: '待审核' },
    { value: 2, label: '已更新' },
    { value: 3, label: '未通过' },
  ],
  //备案审核状态 审批状态：0、已提交(审核中)；1、已通过；2、已拒绝；3、已取消
  'carReviewState':[
    { value: 0, label: '审核中' },
    { value: 1, label: '已通过' },
    { value: 2, label: '已拒绝' },
    { value: 3, label: '已取消' },
  ],


  //'菜单类型：0、导航；1、通用；2、功能' AFTER `name`;
  'menuType':[
    { value: 0, label: '导航' },
    { value: 1, label: '通用' },
    { value: 2, label: '功能' },
    { value: 3, label: '浮动' },
  ],

  //匹配模式：0、精准匹配；1、子路径匹配；2、所有权匹配
  'matchType':[
    { value: 0, label: '精准匹配' },
    { value: 1, label: '子路径匹配' },
    { value: 2, label: '所有权匹配' },
  ],
  //请求方法类型：0、“GET”；1、“POST”；2、“PUT”；3、“DELETE”；4、“PATCH”
  'methodType':[
    { value: 0, label: '全部' },
    { value: 1, label: 'GET' },
    { value: 2, label: 'POST' },
    { value: 3, label: 'PUT' },
    { value: 4, label: 'DELETE' },
    { value: 5, label: 'PATCH' },
  ],

  'job':[
    { value: 0, label: '辅警' },
    { value: 1, label: '民警' },
    { value: 2, label: '中队长' },
    { value: 3, label: '指导员' },
    { value: 4, label: '副大队长' },
    { value: 5, label: '教导员' },
    { value: 6, label: '大队长' },
    { value: 7, label: '副主任' },
    { value: 8, label: '主任' },
    { value: 9, label: '副科长' },
    { value: 10, label: '科长' },
    { value: 11, label: '副政委' },
    { value: 12, label: '副支队长' },
    { value: 13, label: '政委' },
    { value: 14, label: '支队长' },
  ],

  'licenseState':[
    {value:0 , label:'无效'},
    {value:1 , label:'有效'},
  ],

  'licenseTemplateType':[
    {value:0 , label:'证件'},
    {value:1 , label:'牌照'},
  ],

  'licenseSubejctType':[
    { value: 0, label: '快递员' },
    { value: 1, label: '企业' },
  ],

  'licensePolicyType':[
    { value: 0, label: '减少' },
    { value: 1, label: '增加' },
  ],

  'licensePolicyLevel':[
    { value: 1, label: '轻微交通违法' },
    { value: 2, label: '较重交通违法' },
    { value: 3, label: '严重交通违法' },
    { value: 0, label: '正常' },
  ],

  'licenseStrategy':[
    { value: 1, label: '积分' },
    { value: 2, label: '等级' },
  ],
  //状态：0、待审核，1、申诉成功，2、已驳回，3、已取消，4、正常
  'licenseViolationState':[
    { value: 0, label: '待审核' },
    { value: 1, label: '申诉成功' },
    { value: 2, label: '已驳回' },
    { value: 3, label: '已取消' },
    { value: 4, label: '正常' },
  ],

  'licenseLogType':[
    { value: 0, label: '提交' },
    { value: 1, label: '申诉' },
    { value: 2, label: '审核' },
    { value: 3, label: '取消' },
    { value: 4, label: '其他' },
  ]
  ,
  'insuranceReminderState':[
    { value: 0, label: '即将到期' },
    { value: 1, label: '已到期' },
  ],
  'licenseExceptionState':[
    { value: 0, label: '已登记' },
    { value: 1, label: '已取消' },
  ],
  //0、正常；1、一般；2、较重；3、 严重
  'companyWarningStrategy':[
    { value: 0, label: '正常' , color:'#23b3e7' },
    { value: 1, label: '一般' , color:'#f5da25'},
    { value: 2, label: '较重' , color:'#fb9220' },
    { value: 3, label: '严重' , color:'#ca2a2e' },
    { value: 4, label: '其他' , color:'#eeeeee' },
  ],
  'carMixState':[
    // 1 绑定 未行驶
    { value: 1, label: '已绑定', color: '#fb8e20' },
    //未绑定+未欠费
    { value: 2, label: '未绑定', color: '#2ab7e9' },
    //绑定行驶中
    { value: 3, label: '行驶中', color: '#6bd161' },
    { value: 4, label: '欠费锁定', color: '#c92041' },
  ],
  'companyInspectionState':[
    {value:0,label:'正常'},
    {value:1,label:'待整改'},
  ],
  //0、监控设备，1、开箱验视设备，2、实名认证设备
  'companyDeviceType':[
    {value:0,label:'监控设备'},
    {value:1,label:'开箱验视设备'},
    {value:2,label:'实名认证设备'},
  ],
  'companyDevicePlatform':[
    {value:0,label:'海康监控平台'},
  ],
  'batteryStatus':[
    {value:0,label:'移动'},
    {value:1,label:'静止'},
    {value:2,label:'存储'},
    {value:3,label:'休眠'},
  ],
  'batteryAlarmLevel':[
    {value:1,label:'一级'},
    {value:2,label:'二级'},
    {value:3,label:'三级'},
    {value:4,label:'四级'},
  ],
  //商品类型 1车辆 2电池 3保险 4配件
  'productType':[
    { value: 1, label: '车辆' },
    { value: 2, label: '电池' },
    { value: 3, label: '保险' },
    { value: 4, label: '配件' },
  ],

  'productPublishState':[
    { value: 1, label: '上架中' },
    { value: 2, label: '已下架' },
  ]
}


const getRemoteDict = (key , type = 'number' , callback) => {
  let values = []
  request.kv(key).then(resp => {
    if( type == 'number' ){
      values = resp.data.map(i => ({ value: parseInt(i.cKey), label: i.cValue }))
    }else{
      values = resp.data.map(i => ({ value: i.cKey, label: i.cValue }))
    }
    //缓存kv数据
    Object.assign(dicts, { [key]: values })
    callback(values)
  })
}

export const createDict = (key , type = 'number' ) => {
  let cache = dicts[`$${key}`] || dicts[key]
  if(cache) {
    return cache.map( ( rest ) => ({...rest}) )
  }else if (key.startsWith('$$')) {
    return () => new Promise((resolve , reject) => {
      getRemoteDict(key.replace('$$', '') , type , (data) => {
        resolve(data)
      })
    })
  }else if(key.startsWith('@')){
    return () => request(key.replace('@', 'common_'))().then((resp) => {
      return Promise.resolve(resp.data.map(i => ({ value: i.id, label: i.name })))
    })
  }
}

export const parseDict = (data , key , forLabel = false) => {
  let k = 'value' , v = 'label'
  if( forLabel ){
    k = 'label'
    v = 'value'
  }
  let cache = dicts[`$${key}`] || dicts[key]
  let hit = cache.find(i => i[k] === data)
  if( hit ) return hit[v]
}

export default dicts
